import {useParams} from "react-router-dom";
import dayjs from "dayjs";
import React,{useState} from "react";
import {useGetOrganizationSessions} from "../../services/ContentManager";
import SessionTable from "../../components/tables/SessionTable";
import {SESSIONS} from "../../services/Client";

export default function OrganizationSessions() {

    let {id} = useParams();
    const today = dayjs(new Date());//.format("YYYY-MM-DD");
    let [interval, setInterval] = useState({start: today.subtract(14, 'day').format("YYYY-MM-DD"), end: today.format("YYYY-MM-DD")})
    const {sessions = [], status} = useGetOrganizationSessions(id, interval.start, interval.end)

    return <SessionTable sessions={sessions} loading={status === "loading"} interval={interval} setInterval={setInterval} queryKey={[SESSIONS, {start: interval.start, end: interval.end, id}]}/>

}